<template>
  <Modal
    v-model="_value"
    :width="width"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">

<!--    <iframe :src="_initValue" frameborder="0" style="width: 100%; height: 100%"></iframe>-->
<!--    <embed type="application/pdf" :src="_initValue" width="1300" height="650">-->
      <embed type="application/pdf" :src="_initValue" :width="width - 20" :height="height">

  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'iframemodal',
  components: {},
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      height: 500,
      width: 500
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {

      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.height = window.innerHeight - 200
      this.width = window.innerWidth - 60
      // window.onresize = () => {
      //   this.height = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      // }
    })
  }
}
</script>
